import React, { Component } from 'react';

import { Label, Paragraph } from '../../theme';

import { Mecanism } from '../../svg';
import { isMobile } from '../../util';

class CampaignMecanism extends Component {
  render() {
    return (
      <div id="EnelRelax" className="container__fluid mecansim">
        <div className="w__flex w__flex-column Justify-between Align-center">

          <div className="thumb o-2__mobile">
            <Mecanism.Thumb />
          </div>

          {
            !isMobile && (
              <div className="cactus">
                <Mecanism.Cactus />
              </div>
            )
          }

          <div className="cell">
            <Label marginRight="0vw" background="#840050" >
              abonamentul enel fix relaxat
            </Label>
            <ul className="benefits__list">
              <li className="list__item">
                <img src={require('../../../assets/img/mecanism/icon-reducere.png')} alt="" />
                <div><span>15% reducere</span> la valoarea energiei,<br className="mobile__hidden" /> incepand cu 90 lei/an*</div></li>
              <li className="list__item"><img src={require('../../../assets/img/mecanism/icon-an.png')} alt="" />Pret fix timp de 12 luni</li>
              <li className="list__item"><img src={require('../../../assets/img/mecanism/icon-interventie.png')} alt="" /><span> 2 interventii de urgenta/an <sup>**</sup></span></li>
              <li className="list__item"><img src={require('../../../assets/img/mecanism/icon-factura.png')} alt="" />Factura Electronica</li>
              <li className="list__item"><img src={require('../../../assets/img/mecanism/icon-call-center.png')} alt="" />Call-Center dedicat 24/7 pentru interventiile de urgenta</li>
            </ul>
          </div>

          {
            isMobile && (
              <div className="Self-start">
                <a href="https://my.enel.ro/cd/fix-relaxat-arctic" target="_blank" rel="noopener noreferrer" className="btn enel">
                  <span>
                    <span>Cere oferta</span>
                    <img alt="arrow right" src={require('../../../assets/img/icons/pointer-enel.svg')} />

                  </span>
                </a>
              </div>
            )
          }

          <Paragraph normal >
            *Valoarea reducerii este calculata fata de pretul standard al abonamentului de energie Enel Fix Relaxat, pentru un consum mediu lunar de 150 kWh/luna. Promotia este valabila in perioada 16 august – 31 decembrie 2018. Oferta se adreseaza clientilor de tip rezidential pe piata concurentiala ce au achizitionat un produs Arctic si este supusa unor termeni si conditii disponibile pe www.enel.ro
          <br />
            **La instalatiile electrice, de alimentare cu apa, desfundarea instalatiei de canalizare a apei, lacatuserie, repararea boilerelor electrice, in limita a 450 lei/interventie conform termenilor si conditiilor disponibile pe www.enel.ro
          </Paragraph>

          {
            !isMobile && (
              <div className="Self-start">
                <a href="https://my.enel.ro/cd/fix-relaxat-arctic" target="_blank" rel="noopener noreferrer" className="btn enel">
                  <span>
                    <span>Cere oferta</span>
                    <img alt="arrow right" src={require('../../../assets/img/icons/pointer-enel.svg')} />

                  </span>
                </a>
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

export default CampaignMecanism;


// WEBPACK FOOTER //
// ./src/components/pages/Mecanism/EnelRelax.jsx